/**
 * Date-fns locale mapping constant.
 *
 * Canonical mapping consolidated from:
 * - apps/ssm-web4/src/app/utils/dates/index.js (DATEFNS_LOCALES)
 * - apps/ssm-admin/src/utils/datetime.js (LOCALE_DATES)
 *
 * Both had identical mappings. This is the single source of truth.
 */

import { es, enGB, enUS, de, fr, it, pt, ru, ptBR, da } from 'date-fns/locale';

/**
 * Maps BCP 47 locale tags and short codes to date-fns locale objects.
 * @type {Object<string, import('date-fns').Locale>}
 */
export const DATEFNS_LOCALES = {
    'es-ES': es,
    es: es,
    'en-GB': enGB,
    en: enGB,
    'en-US': enUS,
    'de-DE': de,
    'fr-FR': fr,
    'it-IT': it,
    'pt-PT': pt,
    'ru-RU': ru,
    'pt-BR': ptBR,
    'da-DK': da,
};
